import _sfc_main from "./component-library214.mjs";
import "./component-library215.mjs";
import normalizeComponent from "./component-library92.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  _vm._self._setupProxy;
  return _c("div", { staticClass: "dropdown-container", class: { "dropdown-container--right": _vm.showRight, "dropdown-container--auto-width": _vm.autoWidth } }, [_vm.$slots.input ? _c("div", { staticClass: "dropdown-container__input" }, [_vm._t("input")], 2) : _vm._e(), _c("div", { staticClass: "dropdown-container__list" }, [_vm._t("default")], 2), _vm.$slots.submit ? _c("div", { staticClass: "dropdown-container__submit" }, [_vm._t("submit")], 2) : _vm._e()]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "b6d8ac60",
  null,
  null
);
const DropdownContainer = __component__.exports;
export {
  DropdownContainer as default
};
